import type { FC } from 'react';
import cx from 'classnames';

import type { EnquiriesStoreState } from 'Features/SellerCommunications/services';

import { ModalEnquiryListItem } from './ModalEnquiryListItem';

import styles from './ModalEnquiryList.module.scss';

interface ModalEnquiryListItemsProps {
	enquiries: EnquiriesStoreState['enquiries'];
}

export const ModalEnquiryListItems: FC<ModalEnquiryListItemsProps> = ({ enquiries }) => {
	return (
		<>
			{enquiries.map((enquiry) => (
				<div key={`${enquiry.saleId}`} className={cx(styles.item)}>
					<ModalEnquiryListItem
						enquiryId={enquiry.enquiryId}
						leadPhoto={enquiry.leadPhoto}
						make={enquiry.make}
						model={enquiry.model}
						saleId={enquiry.saleId}
						slug={enquiry.state.slug}
						vrm={enquiry.vrm}
					/>
				</div>
			))}
		</>
	);
};
